import React, { useEffect, useState } from "react";
import { Autocomplete, createTheme } from "@mui/material";
import { ThemeProvider } from "@mui/system";
import TextInput from "./TextInput";
import images from "../assets/images/index";
import { isEmpty } from "../utils/utils";
const { arrowUp } = images;
const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        popper: {
          border: "1px solid black",
          borderRadius: 4,
        },
        input: {
          paddingTop: "0 !important",
          paddingBottom: "0 !important",
          marginTop: -3,
        },
        option: {
          "&.Mui-focused": {
            background: "#fdce57 !important",
          },
        },
        "&::-webkit-scrollbar": {
          display: "none",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          height: "auto !important",
        },
      },
    },
  },
});

const SelectInput = React.forwardRef((props, ref) => {
  const {
    id,
    options = [],
    groupBy,
    sx,
    label,
    freeSolo = false,
    autoHighlight = true,
    disableClearable = true,
    blurOnSelect = false,
    size = "medium",
    name,
    value,
    InputProps,
    onChange = () => {},
    onInputChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    getOptionLabel = (option) => option.label,
    getOptionDisabled = () => {},
    isOptionEqualToValue,
    readOnly = false,
    // open,
    markers,
    limitTags,
    multiple = false,
    disableCloseOnSelect = false,
    filterSelectedOptions = false,
    required = false,
    disabled = false,
    renderOption,
    renderGroup,
    error,
    autoFocus,
    openOnFocus = false,
    popupIcon = <img src={arrowUp} alt="arrow" />,
    noOptionsText = "No Options Available",
  } = props;
  const [isPopperOpen, setIsPopperOpen] = useState(true);
  const [autocompleteValue, setAutocompleteValue] = useState(
    multiple ? [] : null
  );
  useEffect(() => {
    if (!isEmpty(value)) {
      setAutocompleteValue(value);
    }
  }, [value]);
  return (
    <ThemeProvider theme={theme}>
      <Autocomplete
        // open={true}
        id={id}
        options={options}
        groupBy={groupBy}
        fullWidth
        filterSelectedOptions={filterSelectedOptions}
        multiple={multiple}
        sx={sx}
        size={size}
        disabled={disabled}
        freeSolo={freeSolo}
        autoHighlight={autoHighlight}
        disableClearable={disableClearable}
        blurOnSelect={blurOnSelect}
        getOptionLabel={getOptionLabel}
        getOptionDisabled={getOptionDisabled}
        value={autocompleteValue}
        isOptionEqualToValue={isOptionEqualToValue}
        readOnly={readOnly}
        openOnFocus={openOnFocus}
        disableCloseOnSelect={disableCloseOnSelect}
        onChange={(event, newValue) => {
          setAutocompleteValue(newValue);
          onChange(event, newValue);
        }}
        onInputChange={(event, value, reason) => {
          if (reason === "reset") return;
          onInputChange(event, value, reason);
        }}
        onBlur={onBlur}
        limitTags={limitTags}
        onFocus={onFocus}
        renderGroup={renderGroup}
        renderOption={renderOption}
        renderInput={(params) => {
          return (
            <TextInput
              {...params}
              label={label}
              size={size}
              ref={ref}
              name={name}
              value={getOptionLabel}
              required={required}
              inputProps={{
                ...params.inputProps,
                "data-markers": markers,
                onKeyUp: (e) => {
                  if (isPopperOpen && e.key === "Escape") {
                    e.stopPropagation();
                    return;
                  }
                },
                onKeyDown: (e) => {
                  if (
                    document.getElementsByClassName("MuiAutocomplete-listbox")
                      .length > 0
                  )
                    return setIsPopperOpen(true);
                  setIsPopperOpen(false);
                },
              }}
              InputProps={{ ...params.InputProps, ...InputProps }}
              error={error}
              autoFocus={autoFocus}
            />
          );
        }}
        popupIcon={popupIcon}
        noOptionsText={noOptionsText}
      />
    </ThemeProvider>
  );
});

export default SelectInput;
